// IdleScreen — what the board shows when nobody is waiting.
//
// A waiting-room TV shouldn't display a wall of empty doctor cards, so when
// every selected doctor's queue is empty QueueV2Display hands the whole area
// over: to full-bleed ads when the hospital runs them, and to this calm
// branded panel otherwise (or when ads are on but none are configured yet).
import React from "react";
import moment from "moment";
import { Logo } from "../../assets/icons/Icons";

interface Props {
  now: string; // pre-formatted clock from the parent (avoids a second timer)
  date: string; // YYYY-MM-DD
}

const IdleScreen: React.FC<Props> = ({ now, date }) => (
  <div className="flex h-full w-full flex-col items-center justify-center rounded-2xl bg-white ring-1 ring-[#E9EDF3]">
    {/* Logo hard-codes 150x37px; sized in rem (×1.8) so it scales with the
        board on small/large TV viewports like everything else. */}
    <div className="[&>svg]:h-[4.1625rem] [&>svg]:w-[16.875rem]">
      <Logo />
    </div>

    <p className="mt-14 text-[5.5rem] font-semibold leading-none tabular-nums text-[#1F2B4D]">
      {now}
    </p>
    <p className="mt-4 text-xl text-[#9AA5B8]">
      {moment(date).format("dddd, DD MMM YYYY")}
    </p>

    <div className="mt-14 rounded-full bg-[#F2F6FC] px-7 py-3 text-lg font-medium text-[#5A6478]">
      No patients in the queue right now
    </div>
    <p className="mt-4 text-sm text-[#AEB7C7]">
      Names will appear here as patients check in.
    </p>
  </div>
);

export default IdleScreen;
